/**
 * Default implementation
 */
export default class DefaultNumberComparer {
    compare(x, y) {
        const result = x - y;
        if (result < 0)
            return -1;
        if (result > 0)
            return 1;
        return result;
    }
    equals(x, y) {
        return x === y;
    }
    greaterThan(x, y) {
        return this.compare(x, y) > 0;
    }
    greaterThanOrEqual(x, y) {
        return this.compare(x, y) >= 0;
    }
    lessThan(x, y) {
        return this.compare(x, y) < 0;
    }
    lessThanOrEqual(x, y) {
        return this.compare(x, y) <= 0;
    }
}
